import type { MessageType } from '../../../model/message/message-type';

export interface NotyData extends NotyConfig {
  bodyText: string;
  type?: MessageType;
  icon?: string;
}

export interface NotyConfig {
  containerClass?: BaseNotyClass;
  showCta: boolean;
  ctaText?: string;
  ctaClick?: () => any;
}

export enum BaseNotyClass {
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
  Default = 'default',
}

export enum StickyNotySize {
  Extra_Small = 'extra-small',
  Small = 'small',
  Normal = 'normal',
}
